import { Benefit } from './view';

export default Benefit;
